import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { TokenInterceptor } from '@core/interceptor/token-interceptor';

import { SystemConfigurationService } from '@core/api/system-configuration/system-configuration.service';
import { environment } from '@env/environment';

// Disable console logs based on environment
function initializeConsoleOverride() {
    // Default to true (logs enabled) if undefined
    const loggingEnabled = environment?.enableLogging ?? true;

    if (!loggingEnabled) {
        const noop = () => {};
        console.log = noop;
        console.debug = noop;
        console.info = noop;
        console.warn = noop;
        console.error = noop;
    }
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAppInitializer(() => {
            initializeConsoleOverride();

            const config = inject(SystemConfigurationService);
            return config.load(); // returns a Promise<void>
        }),
        provideHttpClient(withInterceptors([TokenInterceptor])),
    ],
};
